// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Every other peer's drag (AgentDrags.tsx): over the canvas, the tool rail and
   the catalog drawers, since a drag starts in them, and under API Settings,
   the modals, the toasts and the tooltip. It takes no pointer event. */
.oLIMBEx4q8BaUcEHj3Pg {
  position: fixed;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: var(--curio-z-agent-drags);
}

/* One drag: the point its cursor's tip is at, which its ghost hangs from by
   its top-left corner. It moves on every frame, so it has no transition. */
.W8useANxgN7mtRIPpYg3 {
  position: absolute;
  width: 0;
  height: 0;
}

/* A copy of the tile, row or card it drags, the size it has on the page at any
   zoom: scaled back from its top-left, as the cursor is from its tip. */
.sZbOnVOaTJNQctfCngFd {
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 0 0;
  opacity: 0.85;
  box-shadow: var(--curio-shadow-browse-card-raised);
}

/* The outline of the node it adds or moves, the node's size on the dataflow. */
.ETTcdnToGCIhC5A8a_nU {
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed;
  border-radius: var(--curio-radius-lg);
  background: color-mix(in srgb, currentColor 8%, transparent);
}

.WDhGzqi9JNIHIKYEHdfm {
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 2px 10px;
  border-radius: var(--curio-radius-pill);
  color: #fff;
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-sm);
  font-weight: 600;
  line-height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/collab/AgentDrags.module.css"],"names":[],"mappings":"AAAA;;uEAEuE;AACvE;EACE,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;2EAC2E;AAC3E;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;wEACwE;AACxE;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,qBAAqB;EACrB,aAAa;EACb,kDAAkD;AACpD;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,WAAW;EACX,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* Every other peer's drag (AgentDrags.tsx): over the canvas, the tool rail and\n   the catalog drawers, since a drag starts in them, and under API Settings,\n   the modals, the toasts and the tooltip. It takes no pointer event. */\n.layer {\n  position: fixed;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: var(--curio-z-agent-drags);\n}\n\n/* One drag: the point its cursor's tip is at, which its ghost hangs from by\n   its top-left corner. It moves on every frame, so it has no transition. */\n.drag {\n  position: absolute;\n  width: 0;\n  height: 0;\n}\n\n/* A copy of the tile, row or card it drags, the size it has on the page at any\n   zoom: scaled back from its top-left, as the cursor is from its tip. */\n.copy {\n  position: absolute;\n  left: 0;\n  top: 0;\n  transform-origin: 0 0;\n  opacity: 0.85;\n  box-shadow: var(--curio-shadow-browse-card-raised);\n}\n\n/* The outline of the node it adds or moves, the node's size on the dataflow. */\n.outline {\n  position: absolute;\n  left: 0;\n  top: 0;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed;\n  border-radius: var(--curio-radius-lg);\n  background: color-mix(in srgb, currentColor 8%, transparent);\n}\n\n.outlineLabel {\n  max-width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 2px 10px;\n  border-radius: var(--curio-radius-pill);\n  color: #fff;\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-sm);\n  font-weight: 600;\n  line-height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layer": `oLIMBEx4q8BaUcEHj3Pg`,
	"drag": `W8useANxgN7mtRIPpYg3`,
	"copy": `sZbOnVOaTJNQctfCngFd`,
	"outline": `ETTcdnToGCIhC5A8a_nU`,
	"outlineLabel": `WDhGzqi9JNIHIKYEHdfm`
};
export default ___CSS_LOADER_EXPORT___;
